import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const EquipmentTypeIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg width={circled ? '50%' : '100%'} height={circled ? '50%' : '100%'} viewBox="0 0 15.437 15.482">
      <defs>
        <clipPath>
          <rect width="15.437" height="15.482" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <rect
            width="6.013"
            height="6.013"
            rx="1.219"
            transform="translate(0.5 8.969)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <rect
            width="6.013"
            height="6.013"
            rx="1.219"
            transform="translate(0.5 0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <rect
            width="6.013"
            height="6.013"
            rx="1.219"
            transform="translate(8.925 8.969)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <rect
            width="6.013"
            height="6.013"
            rx="1.219"
            transform="translate(8.925 0.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
